import { useCallback, useEffect, useReducer, ReactElement } from 'react';

import { CrudMode } from '@ohpen/enso-ui';
import { usePmpFetch } from '@pmp/hooks';
import { PmpLenderResponse } from '@pmp/api';

import { LenderDetails } from './LenderDetails';
import { LenderCrudForm } from './LenderCrudForm';
import { getInitialState, reducer } from '../reducer';

export const LenderDetailsSection = (): ReactElement => {
  const [isFetching, , data, , fetchData] = usePmpFetch('lendersGetLender');
  const [state, dispatch] = useReducer(reducer<PmpLenderResponse>, getInitialState<PmpLenderResponse>());

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const onEdit = useCallback((record: PmpLenderResponse) => {
    dispatch({ type: 'openCrud', record, mode: CrudMode.EDIT });
  }, []);

  const onCloseCrud = useCallback(() => {
    dispatch({ type: 'closeCrud' });
  }, []);

  return (
    <>
      <LenderDetails details={data ?? null} isFetching={isFetching} onEdit={onEdit} />
      {state.crud.open && state.crud.mode && (
        <LenderCrudForm mode={state.crud.mode} record={state.crud.record} onClose={onCloseCrud} refreshTable={fetchData} />
      )}
    </>
  );
};
